import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import WeeklySchedule from '@/types/table/weeklySchedule';
import { FilesManageData } from '@/api/generated/filesManageController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface WeeklyScheduleData extends WeeklySchedule {
  filesManage?: FilesManageData;
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class WeeklyScheduleController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WeeklyScheduleData>>(API_CONTEXT + '/app/weeklySchedule/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<WeeklyScheduleData>(API_CONTEXT + '/app/weeklySchedule/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/weeklySchedule/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/weeklySchedule/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/weeklySchedule/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/weeklySchedule/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/weeklySchedule/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/weeklySchedule/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/weeklySchedule/deleteBatch', params, httpOptions);
  }
}
